export const SET_LOGGED_USER="app/loggedUser/SET_LOGGED_USER"
export const SET_CURRENT_ACCOUNT="app/loggedUser/SET_CURRENT_ACCOUNT"
